import { baseApi } from "./baseApi";

const PHYSICIAN_URL = "/doc-aide-svc/physicians";

export const physicianApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPhysicianDetails: builder.query({
      query: (preferredUsername) =>
        `${PHYSICIAN_URL}?PhysicianID=${preferredUsername}`,
      transformResponse: (response) => response.Physicians,
    }),
    getPhysicianAppointments: builder.query({
      query: ({ physicianID, filterStartDate, filterEndDate, search = "" }) =>
        `/doc-aide-svc/appointments/get_appointments_by_physician_id_and_date_range?PhysicianID=${physicianID}&StartDate=${filterStartDate}&EndDate=${filterEndDate}&search_string=${search}`,
    }),
    getPhysicianPatientsList: builder.query({
      query: ({ physicianID, currentPage, pageSize, search = "" }) =>
        `/doc-aide-svc/patients/patients_by_phygician_id?PhysicianID=${physicianID}&page=${currentPage}&page_size=${pageSize}&search_string=${search}`,
    }),
    getPhysicianByHospitalId: builder.query({
      query: ({ hospitalId, physicianId = "" }) =>
        `${PHYSICIAN_URL}/get_physicians_by_hospitalidindex?HospitalID=${hospitalId}&PhysicianID=${physicianId}`,
      transformResponse: (response) => response?.Physicians,
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetPhysicianDetailsQuery,
  useGetPhysicianAppointmentsQuery,
  useGetPhysicianPatientsListQuery,
  useGetPhysicianByHospitalIdQuery,
} = physicianApi;
